export default __webpack_public_path__ + "static/media/guy--desktop@2x.4ef24293.jpg";